import { useQuery } from '@tanstack/react-query';
import { loadPayoutsFromStorage } from '../storage';

export function usePayouts() {
  return useQuery({
    queryKey: ['payouts'],
    queryFn: async () => {
      const payouts = await loadPayoutsFromStorage();
      return payouts;
    },
  });
}

